import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function TargetAudience() {
  const cards = [{
    icon: '💼',
    title: 'Empleados en relación de dependencia',
    desc: 'Trabajás todo el mes y sentís que el sueldo no te alcanza. Con El Costo de No Hacer Nada vas a tener un sistema real — no solo buenas intenciones.',
    bullets: ['Método de las 3 cuentas para que el ahorro ocurra solo', 'Plan de 30 días para implementarlo desde hoy']
  }, {
    icon: '🧾',
    title: 'Autónomos e independientes',
    desc: 'Tenés ingresos irregulares y no sabés cómo planificar. Con El Costo de No Hacer Nada vas a poder ordenar tu plata sin importar cuánto varíe tu ingreso mes a mes.',
    bullets: ['Sistema adaptado a sueldos irregulares', 'Fondo de emergencia para los meses flojos']
  }, {
    icon: '📈',
    title: 'Los que nunca invirtieron',
    desc: 'Nunca pusiste un peso en nada y el miedo a equivocarte te paraliza. El Pack Completo te da el método completo, el segundo ingreso y el plan a 5 años validados para Argentina 2026.',
    bullets: ['Checklist paso a paso para tu primera inversión', 'Instrumentos reales: CEDEARs, FCI, plazo fijo UVA']
  }];
  return <section className="bg-navy text-white py-16 px-4" data-id="element-237">
      <div className="max-w-[720px] mx-auto" data-id="element-238">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 leading-tight" data-id="element-239">
          ¿Este sistema es para vos?
        </h2>

        <div className="flex flex-col gap-6" data-id="element-240">
          {cards.map((card, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 p-6 rounded-2xl" data-id="element-241">
              <div className="flex items-center gap-3 mb-4" data-id="element-242">
                <span className="text-2xl" data-id="element-243">{card.icon}</span>
                <h3 className="text-lg font-bold text-gold" data-id="element-244">{card.title}</h3>
              </div>
              <p className="text-[15px] text-white/80 mb-5 leading-[1.6]" data-id="element-245">
                {card.desc}
              </p>
              <ul className="space-y-3" data-id="element-246">
                {card.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-[14px] text-white/90" data-id="element-247">
                    <Check className="text-emerald flex-shrink-0 mt-0.5" size={18} data-id="element-248" />
                    <span data-id="element-249">{bullet}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}